// extracted by mini-css-extract-plugin
module.exports = {"rendering_pixelated":"ColorFinderFootageDisplay_rendering_pixelated__zenbr"};